export default "__VITE_ASSET__Caev7MNL__"